<template>
  <div class="login-page">
    <app-navbar />
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using:
          data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-6 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h4 class="header text-center">
                  Oops! Looks like your clock isn't accurate.
                </h4>
                <p class="text-center">
                  For security purposes, your computer's clock needs to be
                  accurate to authenticate with Acts.
                  <b>For most computers, you can sync your clock in
                    Settings > Date and Time > Synchronize.</b>
                  Once you have the correct time, click the button below to log back in!
                </p>
                <p-button
                  native-type="submit"
                  slot="footer"
                  round
                  block
                  class="mb-3 return-to-login"
                  @click="returnToLogin"
                >
                  Return to Login Page
                </p-button>
                <a class="help-link" :href="smartsheet" target="_blank">
                  Contact Support
                </a>
              </card>
            </div>
          </div>
        </div>
        <app-footer />
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) " />
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from 'src/components/Layout/LoginAppNavbar';
import AppFooter from 'src/components/Layout/LoginAppFooter';

export default {
    components: {
        AppNavbar,
        AppFooter
    },
    data() {
        return {
            smartsheet: process.env.VUE_APP_SMARTSHEET
        };
    },
    methods: {
        returnToLogin() {
            this.$router.push('/login');
        }
    }
};
</script>
  <style>
  .return-to-login {
    background-color: #0B3B60 !important;
  }
  .help-link {
    bottom: 0;
    position: absolute;
    padding: 10px; /* Adjust padding as needed */
    color: #66b1ff !important;
    left: 50%;
    transform: translateX(-50%);
  }
  </style>
